import { useBusiness } from './useBusiness';
import { useColors } from './useColors';
import { useFooter } from './useFooter';
import { useForm } from './useForm';
import { useGallery } from './useGallery';
import { useLists } from './useLists';
import { useLogos } from './useLogos';
import { useMap } from './useMap';
import { useNavbars } from './useNavbars';
import { usePages } from './usePages';
import { useServices } from './useServices';
import { useTestimonials } from './useTestimonials';
import { useGlobalOptions } from './useGlobalOptions';

const useSanityData = () => {
  const hooks = [
    { name: 'business', hook: useBusiness },
    { name: 'colors', hook: useColors },
    { name: 'footer', hook: useFooter },
    { name: 'form', hook: useForm },
    { name: 'gallery', hook: useGallery },
    { name: 'lists', hook: useLists },
    { name: 'logos', hook: useLogos },
    { name: 'map', hook: useMap },
    { name: 'navbars', hook: useNavbars },
    { name: 'pages', hook: usePages },
    { name: 'services', hook: useServices },
    { name: 'testimonials', hook: useTestimonials },
    { name: 'globalOptions', hook: useGlobalOptions },
    // Add more hooks here as needed
  ];

  const combinedData = hooks.reduce((acc, { name, hook }) => {
    const hookData = hook();
    acc[name] = hookData || {};
    return acc;
  }, {});

  return combinedData;
};

export { useSanityData };
